import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Icon from "./Icon";
import { useSession } from "../session";
import { money } from "../utils";

const ThanksPage = () => {
  const location = useLocation();
  const session = useSession();
  const order = location.state;

  return (
    <>
      <Header />
      <main className="page container" id="main">
        <section className="card thanks" aria-labelledby="thanks-title">
          <span className="thanks-icon" aria-hidden="true">
            <Icon name="check" size={34} strokeWidth={2.6} />
          </span>
          <h1 id="thanks-title">{order ? "Order placed!" : "Thanks for shopping with QKart"}</h1>
          {order ? (
            <p>
              We’re getting your {order.items} {order.items === 1 ? "item" : "items"} ready. {money(order.total)} was
              paid from your wallet.
            </p>
          ) : (
            <p>Your orders are on their way.</p>
          )}
          {session.loggedIn && (
            <p className="thanks-balance">
              Wallet balance <strong>{money(session.balance)}</strong>
            </p>
          )}
          <Link to="/" className="btn btn-primary btn-lg">
            Continue shopping
          </Link>
        </section>
      </main>
      <Footer />
      <style>{`
        .thanks { max-width: 560px; margin: 24px auto; padding: clamp(28px, 5vw, 48px); display: flex; flex-direction: column; align-items: center; text-align: center; gap: 14px; }
        .thanks h1 { margin: 0; font-size: clamp(26px, 4vw, 34px); font-weight: 800; letter-spacing: -0.02em; }
        .thanks p { margin: 0; color: var(--text-2); max-width: 420px; }
        .thanks-icon { width: 72px; height: 72px; border-radius: 50%; background: var(--brand-soft); color: var(--brand); display: grid; place-items: center; }
        .thanks-balance { padding: 10px 16px; border-radius: 12px; background: var(--surface-2); }
        .thanks .btn { margin-top: 8px; }
      `}</style>
    </>
  );
};

export default ThanksPage;
